import { config } from '@/config';
import { PATH } from '@/constants/path';
import { Button, ButtonGroup, Frame, Page, PageProps } from '@shopify/polaris';
import { HomeIcon } from '@shopify/polaris-icons';
import { memo, Suspense, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FooterHelpText from '../FooterHelpText/FooterHelpText';
import Toast from '../Toast/Toast';
import { LayoutStyled } from './styled';

const btnGroup = [
  {
    content: 'Onboarding',
    path: PATH.ONBOARDING,
  },
  {
    content: 'Home',
    icon: HomeIcon,
    path: PATH.DEFAULT,
  },
  {
    content: 'Locations',
    path: PATH.LOCATIONS,
  },
  {
    content: 'Shipping',
    path: PATH.SHIPPING,
  },
  {
    content: 'Widget Appearance',
    path: PATH.WIDGET,
  },
  {
    content: 'Translation',
    path: PATH.TRANSLATION,
  },
  {
    content: 'General Settings',
    path: PATH.SETTINGS__CHECKOUT,
  },
  {
    content: 'Order Report',
    path: PATH.REPORT,
  },
  {
    content: 'Pricing',
    path: PATH.PRICING,
  },
];

interface ILayoutProps extends PageProps {
  headers?: React.ReactNode;
}

const Layout = ({ ...props }: ILayoutProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LayoutStyled>
      <Frame>
        <Toast />
        {config.embedded !== '1' || config.scope === 'omegatheme' ? (
          <div className="nav-bar">
            <ButtonGroup fullWidth gap="extraTight">
              {btnGroup.map((item, index) => {
                return (
                  <Button
                    key={index}
                    icon={item.icon}
                    variant={
                      location.pathname.includes(item.path.pathname) || (index === 0 && location.pathname === '/')
                        ? 'primary'
                        : undefined
                    }
                    onClick={() => {
                      navigate({
                        ...item.path,
                      });
                    }}
                  >
                    {item.content}
                  </Button>
                );
              })}
            </ButtonGroup>
          </div>
        ) : null}
        {props.headers || null}
        <Suspense
          fallback={
            <div
              style={{
                opacity: 0,
                minHeight: 'calc(100vh - 5rem)',
                width: '100%',
              }}
            >
              Loading...
            </div>
          }
        >
          <Page {...props}>
            <div>{props.children}</div>
            {location.pathname !== PATH.LOCATIONS.pathname && location.pathname !== PATH.WIDGET.pathname && (
              <FooterHelpText linkDocs={'https://docs.dingdoong.io/dashboard/dashboard'} isShowContact={true} />
            )}
          </Page>
        </Suspense>
      </Frame>
    </LayoutStyled>
  );
};
export default memo(Layout);
